<span
  [class]="['notification', 'notification-' + type, size, theme]"
  [class.transparent]="transparent"
>
  <studio-icon [name]="type"></studio-icon>
  <div class="content">
    <ng-content></ng-content>
    <p *ngIf="description" class="description">
      {{ description }}
    </p>
  </div>
</span>
